import { createFileRoute } from '@tanstack/react-router';

import { PlanPage } from '@/features/setting/page/plan-page';

export const Route = createFileRoute('/workspace/$workspaceId/plan-required')({
  component: PlanRequiredPage,
});

function PlanRequiredPage() {
  return (
    <div className="flex h-screen w-full items-center justify-center">
      <PlanPage />
    </div>
  );
}
